import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Muted autoplay for decorative/ambient video loops.
  // Intentionally no `autoplay` attribute in the HTML — this controller is the
  // sole playback trigger so it can respect prefers-reduced-motion (show poster
  // only) and upgrade preload from "metadata" to "auto" on demand.
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.play = this.play.bind(this)
    this.onVisibilityChange = this.onVisibilityChange.bind(this)

    this.element.muted = true
    this.element.defaultMuted = true
    this.element.playsInline = true
    this.element.preload = "auto"

    this.element.addEventListener("loadeddata", this.play)
    this.element.addEventListener("canplay", this.play)
    document.addEventListener("visibilitychange", this.onVisibilityChange)

    this.play()
  }

  disconnect() {
    this.element.removeEventListener("loadeddata", this.play)
    this.element.removeEventListener("canplay", this.play)
    document.removeEventListener("visibilitychange", this.onVisibilityChange)
  }

  play() {
    const promise = this.element.play()
    promise?.catch(() => {})
  }

  onVisibilityChange() {
    if (!document.hidden) this.play()
  }
}
